"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ORDER_HTML_RECEIPT = void 0;
const client_1 = require("@apollo/client");
exports.GET_ORDER_HTML_RECEIPT = client_1.gql `
  query orderReceiptHTMLBase64($idOrder: ID! $canceled: Boolean) {
    orderReceiptHTMLBase64(idOrder: $idOrder canceled: $canceled)
  }
`;
